export default [
    { value: 0, label: "Hourly", hideMin: false, hideMax: false },
    { value: 1, label: "Daily", hideMin: false, hideMax: false},
    { value: 2, label: "Weekly", hideMin: false, hideMax: false },
    { value: 3, label: "Monthly", hideMin: false, hideMax: false },
    { value: 4, label: "Fixed", hideMin: true, hideMax: false },
    { value: 5, label: "Yearly", hideMin: false, hideMax: false}
  ];